"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Msn = exports.ManufacturingInfoFromMsn = exports.ManufacturingInfoFromStruct = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../../schema");
const Regex = __importStar(require("../../../../utils/regex"));
const NAMESPACE = 'Culligan.Device.Class.Pelican2.Msn';
const CustomerFromCode = effect_1.Schema.transformLiterals(['ID', 'Quench']).annotations({
    identifier: `${NAMESPACE}.CustomerFromCode`,
});
const ModelFromCode = effect_1.Schema.transformLiterals(['830', 'Twist']).annotations({
    identifier: `${NAMESPACE}.ModelFromCode`,
});
const FormFactorFromCode = effect_1.Schema.transformLiterals(['F', 'FS'], ['C', 'CT']).annotations({
    identifier: `${NAMESPACE}.FormFactorFromCode`,
    documentation: 'FS = Freestanding; CT = Countertop',
});
const FilterTypeFromCode = effect_1.Schema.transformLiterals(['R', 'RO'], ['U', 'UF'], ['0', 'None']).annotations({
    identifier: `${NAMESPACE}.FilterTypeFromCode`,
    documentation: 'RO = Reverse osmosis; UF = Ultrafiltration',
});
const ColorFromCode = effect_1.Schema.transformLiterals(['B', 'Black'], ['G', 'Grey']).annotations({
    identifier: `${NAMESPACE}.ColorFromCode`,
});
const DestinationFromCode = effect_1.Schema.transformLiterals(['0', 'US'], ['1', 'Chile'], ['2', 'South Africa'], ['3', 'Lithuania'], ['S', 'Spain'], ['B', 'Brunei'], ['D', 'Domestic']).annotations({
    identifier: `${NAMESPACE}.DestinationFromCode`,
});
const MINIMUM_YEAR = 2020;
const YearFromCode = effect_1.Schema.transform(effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[A-Z]$/)), effect_1.Schema.Int.pipe(effect_1.Schema.between(MINIMUM_YEAR, 2045)), {
    strict: true,
    decode: letter => {
        const offset = letter.charCodeAt(0) - 'A'.charCodeAt(0);
        return MINIMUM_YEAR + offset;
    },
    encode: year => {
        const offset = year - MINIMUM_YEAR;
        return String.fromCharCode('A'.charCodeAt(0) + offset);
    },
}).annotations({
    identifier: `${NAMESPACE}.YearFromCode`,
    documentation: '2020 = A; valid through 2045 (Z)',
});
class ManufacturingInfoFromStruct extends effect_1.Schema.Class(`${NAMESPACE}.ManufacturingInfoFromStruct`)({
    customer: CustomerFromCode,
    model: ModelFromCode,
    formFactor: FormFactorFromCode,
    filterType: FilterTypeFromCode,
    color: ColorFromCode,
    destination: DestinationFromCode,
    productionYear: YearFromCode,
    productionDayOfYear: (0, schema_1.EncodePadStart)(3, '0').pipe(effect_1.Schema.compose(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.between(1, 366)))),
    productionSequence: (0, schema_1.EncodePadStart)(3, '0').pipe(effect_1.Schema.compose(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.between(1, 999)))),
}, { identifier: `${NAMESPACE}.ManufacturingInfoFromStruct` }) {
    get manufacturingDateTime() {
        return effect_1.DateTime.unsafeMake({
            year: this.productionYear,
            day: this.productionDayOfYear,
        });
    }
}
exports.ManufacturingInfoFromStruct = ManufacturingInfoFromStruct;
exports.ManufacturingInfoFromMsn = (0, schema_1.CapturePattern)(new RegExp(String.raw `^` +
    String.raw `(?<customer>${Regex.Pattern.oneOf(CustomerFromCode.from.literals)})` +
    String.raw `(?<model>${Regex.Pattern.oneOf(ModelFromCode.from.literals)})` +
    String.raw `(?<formFactor>${Regex.Pattern.oneOf((0, schema_1.encodedLiterals)(FormFactorFromCode))})` +
    String.raw `(?<filterType>${Regex.Pattern.oneOf((0, schema_1.encodedLiterals)(FilterTypeFromCode))})` +
    String.raw `(?<color>${Regex.Pattern.oneOf((0, schema_1.encodedLiterals)(ColorFromCode))})` +
    String.raw `(?<destination>${Regex.Pattern.oneOf((0, schema_1.encodedLiterals)(DestinationFromCode))})` +
    String.raw `(?<productionYear>[A-Z])` +
    String.raw `(?<productionDayOfYear>\d{3})` +
    String.raw `(?<productionSequence>\d{3})` +
    String.raw `$`), ManufacturingInfoFromStruct, ({ customer, model, formFactor, filterType, color, destination, productionYear, productionDayOfYear, productionSequence, }) => effect_1.Effect.succeed([
    customer,
    model,
    formFactor,
    filterType,
    color,
    destination,
    productionYear,
    productionDayOfYear,
    productionSequence,
].join(''))).annotations({ identifier: `${NAMESPACE}.ManufacturingInfoFromMsn` });
exports.Msn = effect_1.Schema.encodedBoundSchema(exports.ManufacturingInfoFromMsn).annotations({
    identifier: `${NAMESPACE}.Msn`,
    examples: ['ID830F0G0E345001'],
});
//# sourceMappingURL=msn.js.map